import React, { memo } from 'react'

import {
  string,
  bool,
  shape,
  arrayOf,
  oneOf,
  number,
} from 'prop-types'

import {
  pricingAreaMockedData,
  freePricingAreaMockedData,
  subscriptionPricingAreaMockedData,
} from 'Pods/Shared/ItemPageComponents/Mocks/pricingArea'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import PricingArea from './Components/PricingArea/PricingArea'

function PricingAreaWrapper({
  pricingAreaData,
  badgesArea = EMPTY_ARRAY,
  extractingCoreStyles = false,
  locale = 'en',
}) {
  return extractingCoreStyles ? (
    <div className="extraction-versions-wrapper">
      <PricingArea {...pricingAreaMockedData} extractingCoreStyles mockedIsInCart />
      <PricingArea {...pricingAreaMockedData} badges={[]} extractingCoreStyles mockedIsProductOwned />
      <PricingArea {...pricingAreaMockedData} badges={[]} extractingCoreStyles />
      <PricingArea {...freePricingAreaMockedData} extractingCoreStyles />
      <PricingArea {...subscriptionPricingAreaMockedData} badges={[]} extractingCoreStyles mockedShowSubscription />
      <PricingArea
        {...subscriptionPricingAreaMockedData}
        badges={[]}
        extractingCoreStyles
        mockedShowSubscription
        mockedIsActiveSubscriber
      />
    </div>
  ) : (
    <PricingArea {...pricingAreaData} badges={badgesArea} locale={locale} />
  )
}


PricingAreaWrapper.propTypes = {
  pricingAreaData: shape({
    productId: number.isRequired,
    title: string.isRequired,
    price: string.isRequired,
    free: bool.isRequired,
    license: oneOf([
      'custom',
      'custom_no_ai',
      'editorial',
      'editorial_no_ai',
      'editorial_royalty_free',
      'royalty_free',
      'royalty_free_no_ai',
    ]).isRequired,
    customLicense: string,
    publishedAiFriendly: bool,
    reviewsCount: number.isRequired,
    ratingScore: number.isRequired,
  }).isRequired,
  badgesArea: arrayOf(oneOf([
    'BEST PRICE GUARANTEED',
    'NEW',
    'TOP SELLING',
    'QUALITY VERIFIED',
    '3D PRINT VERIFIED',
    'TOP RATED',
    'AI GENERATED',
    'DESIGNER\'S PICK',
  ])),
  extractingCoreStyles: bool,
  locale: string,
}

export default memo(PricingAreaWrapper)
